import React, { Component } from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { compose, graphql } from 'react-apollo';
import Modal from 'react-bootstrap/Modal';
import LoadingIndicator from 'components/LoadingIndicator';
import TextButton from 'components/TextButton';
import MascotAlana from './assets/Mascot-Alana@2x.png';
import './AccountCreationModal.css';

class AccountCreationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasAttemptedCreation: false,
      accountCreationSuccess: null,
      errorMessages: null
    };
  }

  handleCreateAccount = () => {
    const { accountType } = this.props;
    this.setState({ hasAttemptedCreation: true });
    this.props
      .createCmpPlsAccount(accountType)
      .then(this.handleMutationResponse)
      .catch(error => {
        this.setState({ accountCreationSuccess: false });
        console.error('Errors', error.toString());
      });
  };

  handleMutationResponse = response => {
    const { createCmpPlsAccount } = response.data;
    if (createCmpPlsAccount.success) {
      this.setState({ accountCreationSuccess: true });
    } else {
      const errorMessages = this.extractErrors(createCmpPlsAccount);
      this.setState({ errorMessages: errorMessages });
      this.setState({ accountCreationSuccess: false });
    }
  };

  extractErrors = data => {
    const errorFieldsOnly = Object.keys(data).filter(
      key => key !== 'success' && key !== '__typename'
    );
    return errorFieldsOnly
      .flatMap(field => data[field])
      .filter(message => message.length > 0);
  };

  handleContinue = () => {
    this.props.onFinalizeSelection(this.props.location);
    this.props.onClose();
  };

  handleClose = () => {
    this.setState({
      hasAttemptedCreation: false,
      accountCreationSuccess: null,
      errorMessages: null
    });
    this.props.onClose();
  };

  renderTopInitialMessage = () => (
    <>
      <p>You do not have an account for this location.</p>
      <p>
        You will not be able to Redeem anything from the WStore until you set up
        an account.
      </p>
    </>
  );

  renderTopSuccessMessage = () => (
    <>
      <p>I went ahead and set up an account for you.</p>
      <p>Congratulations!</p>
    </>
  );

  renderErrorMessages = () => {
    const { errorMessages } = this.state;
    return (
      errorMessages &&
      errorMessages.map((err, idx) => (
        <div key={idx} className="error">
          {err}
        </div>
      ))
    );
  };

  renderTopSection = () => {
    const { accountCreationSuccess, hasAttemptedCreation, errorMessages } =
      this.state;

    if (hasAttemptedCreation && !accountCreationSuccess && !errorMessages) {
      return <LoadingIndicator />;
    } else {
      return (
        <div className="account-creation-message-container">
          <div className="container-left-panel">
            <img src={MascotAlana} alt="" />
          </div>
          <div className="container-right-panel">
            {!hasAttemptedCreation && this.renderTopInitialMessage()}
            {hasAttemptedCreation &&
              accountCreationSuccess &&
              this.renderTopSuccessMessage()}
            {!accountCreationSuccess &&
              errorMessages &&
              this.renderErrorMessages()}
          </div>
        </div>
      );
    }
  };

  renderInitialBottomButtons = () => {
    return (
      <>
        <div className="account-creation-q">Do you want to set one up now?</div>
        <div className="account-creation-buttons">
          <TextButton
            className="button-color-blue main-btn"
            onClick={this.props.onClose}
          >
            No
          </TextButton>
          <TextButton
            className="button-color-green main-btn"
            onClick={this.handleCreateAccount}
          >
            Yes
          </TextButton>
        </div>
      </>
    );
  };

  renderSuccessBottomButtons = () => {
    return (
      <>
        <div className="account-creation-q">
          You can see your account information in the PROFILE section.
        </div>
        <div className="account-creation-buttons">
          <TextButton
            className="button-color-green main-btn"
            onClick={this.handleContinue}
          >
            Continue
          </TextButton>
        </div>
      </>
    );
  };

  renderCloseButton = () => {
    return (
      <div className="account-creation-buttons">
        <TextButton
          className="button-color-red main-btn"
          onClick={this.props.onClose}
        >
          Close
        </TextButton>
      </div>
    );
  };

  renderBottomSection = () => {
    const { accountCreationSuccess, hasAttemptedCreation, errorMessages } =
      this.state;
    return (
      <div className="account-creation-bottom">
        {!hasAttemptedCreation && this.renderInitialBottomButtons()}
        {hasAttemptedCreation &&
          accountCreationSuccess &&
          this.renderSuccessBottomButtons()}
        {!accountCreationSuccess && errorMessages && this.renderCloseButton()}
      </div>
    );
  };

  render() {
    return (
      <Modal className="modal-dialog-account-creation" show={true}>
        <Modal.Body>
          {this.renderTopSection()}
          {this.renderBottomSection()}
        </Modal.Body>
      </Modal>
    );
  }
}

AccountCreationModal.propTypes = {
  createAccount: PropTypes.shape({
    accountType: PropTypes.string,
    location: PropTypes.string
  }),
  onClose: PropTypes.func.isRequired,
  onFinalizeSelection: PropTypes.func.isRequired
};

const MUTATION_CREATE_CMP_PLS_ACCOUNT = gql`
  mutation createCmpPlsAccount($input: CreateCmpPlsAccountInput!) {
    createCmpPlsAccount(input: $input) {
      success
      firstNameErrorMessage
      lastNameErrorMessage
      emailErrorMessage
      displayNameErrorMessage
      dateOfBirthErrorMessage
      passwordErrorMessage
      confirmPasswordErrorMessage
      agreeToTOSErrorMessage
      existingRewardsNumberErrorMessage
      eventCodeErrorMessage
      pinErrorMessage
      genderErrorMessage
      preferredLanguageErrorMessage
      preferredLocationErrorMessage
      addressErrorMessage
      cityErrorMessage
      countryErrorMessage
      stateErrorMessage
      zipCodeErrorMessage
      mobilePhoneErrorMessage
      allowReceiveRewardsViaTextErrorMessage
      genericError
    }
  }
`;

export default compose(
  graphql(MUTATION_CREATE_CMP_PLS_ACCOUNT, {
    props: ({ mutate }) => ({
      createCmpPlsAccount: type =>
        mutate({
          variables: {
            input: {
              accountSystemType: type
            }
          }
        })
    })
  })
)(AccountCreationModal);
